var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getTypesetDOMStyle, Paragraph as BaseParagraph, SylPlugin } from '@syllepsis/adapter';
import { addAttrsByConfig, constructTypesetParseDOM, getFromDOMByConfig, setDOMAttrByConfig, } from '../../utils';
var Paragraph = /** @class */ (function (_super) {
    __extends(Paragraph, _super);
    function Paragraph(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        // because the attrs can be set render or not by props, here keep the default toDOMAttrs
        _this.toDOMAttrs = {};
        _this.formatAttrs = function (v) { return v; };
        _this.defaultFontSize = 16;
        _this.constructParseDOM = function (config) {
            var _a = constructTypesetParseDOM(config), defaultFontSize = _a.defaultFontSize, formatAttrs = _a.formatAttrs, defaultAttrs = _a.defaultAttrs;
            _this.toDOMAttrs = __assign(__assign({}, _this.attrs), defaultAttrs);
            // TODO other non-built-in node handling
            var hasInlineImage = false;
            setTimeout(function () { var _a; return (hasInlineImage = (_a = _this.editor.view.state.schema.nodes.image) === null || _a === void 0 ? void 0 : _a.isInline); });
            _this.canMatch = config.canMatch || (function (dom) { return (hasInlineImage ? true : !/<img/.test(dom.innerHTML)); });
            _this.defaultFontSize = defaultFontSize;
            _this.formatAttrs = function (attrs, dom) {
                var formattedAttrs = formatAttrs(attrs);
                dom && getFromDOMByConfig(_this.props.addAttributes, dom, formattedAttrs);
                return formattedAttrs;
            };
            if (config.addMatchTags) {
                var parseRule_1 = _this.parseDOM[0];
                config.addMatchTags.forEach(function (tagName) { return _this.parseDOM.push(__assign(__assign({}, parseRule_1), { tag: tagName })); });
            }
        };
        _this.toDOM = function (node) {
            var attrs = {};
            var nodeAttrs = __assign({}, node.attrs);
            var addAttributes = _this.props.addAttributes;
            var style = getTypesetDOMStyle(_this.formatAttrs(nodeAttrs), _this.toDOMAttrs);
            if (style)
                attrs.style = style;
            var extraAttrs = {};
            if (nodeAttrs.class)
                extraAttrs.class = nodeAttrs.class;
            setDOMAttrByConfig(addAttributes, node, Object.assign(attrs, extraAttrs));
            return ['p', attrs, 0];
        };
        _this.editor = editor;
        if (props) {
            _this.constructParseDOM(props);
            addAttrsByConfig(_this.props.addAttributes, _this);
            _this.constructParseDOM(_this.props);
        }
        return _this;
    }
    return Paragraph;
}(BaseParagraph));
var ParagraphPlugin = /** @class */ (function (_super) {
    __extends(ParagraphPlugin, _super);
    function ParagraphPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'paragraph';
        _this.Schema = Paragraph;
        return _this;
    }
    return ParagraphPlugin;
}(SylPlugin));
export { Paragraph, ParagraphPlugin };
//# sourceMappingURL=index.js.map